<template lang="pug">
  .service-content-container
    .service-content__desc
      .content__desc__title {{ $t('营销行业人才平台') }}
      .content__desc {{ $t('已经有超过300家品牌方和agency，在使用好快活寻找全职和freelancer人才。') }}
      .content__desc {{$t('同时有超过20000名一线营销人才，在好快活塑造个人IP，分享自身才华。')}}
    .service-container__subTitle
      img(src="@/assets/icon-challenge.png")
      .subTitle {{ $t('企业面临的挑战与痛点') }}

    .service-challenge-container.service-challenge-container__min
      .challenge__item
        img(
          src="@/assets/service-icon3.png"
        )
        //- i.iconfont.iconjiage(
        //-   style="width: 23px"
        //- )
        .item__title {{ $t('招聘周期长') }}
        .item__desc {{ $t('通常企业招聘需要邀约面试、职位分析、入职培训等流程，且面向社会各行业人群，整体耗时较长。') }}
      .challenge__item
        img(
          src="@/assets/service-icon4.png"
        )
        //- i.iconfont.iconpinggu(
        //-   style="width: 17px"
        //- )
        .item__title {{ $t('沟通成本高') }}
        .item__desc {{ $t('候选人参差不齐，沟通效率低下，符合用人部门的简历数量较少，HR面对人群较广，难以逐一了解候选人的真实需求。') }}
    .service-container__subTitle
      img(src="@/assets/icon-project.png")
      .subTitle {{ $t('复歌的解决方案') }}

    .service-solution-container
      .solution-item
        img(
          src="@/assets/quan-item-1.png"
        )
        .solution-content
          .solution-content__title {{ $t('团队专业') }}
          .solution-content__desc {{ $t('专业猎头团队，对营销行业人力资源有深入研究，对企业的职位分析准确率较高，为企业节省大量沟通成本和时间成本。')}}
      .solution-item
        .solution-content
          .solution-content__title {{ $t('人才质量高') }}
          .solution-content__desc {{ $t('专注营销人才寻访，专业化人才数据库，帮助企业进行科学有效的面试，反复甄选，确保推荐人选与岗位高度匹配。')}}
        img(
          src="@/assets/quan-item-2.png"
        )
      .solution-item
        img(
          src="@/assets/quan-item-3.png"
        )
        .solution-content
          .solution-content__title {{ $t('成本较低') }}
          .solution-content__desc {{ $t('后付费模式，确保人才入职后支付费用，降低企业招人成本和二次招聘风险。')}}
</template>

<script>
export default {
  components: {

  }
}
</script>
